define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Başka bir kullanıcı kaydet",

    'incrowd_stats.num_responders': "{{num}} Uzman Sağlık Çalışanı",
    'incrowd_stats.num_answers': "{{num}} Soru Cevaplandı",
    'incrowd_stats.time_to_complete': "Ortalama Anketi Tamamlamak İçin {{num}} Dakika",

    // INCROWD
    'incrowd.about': "Hakkında",
    'incrowd.contact': "İletişim",
    'incrowd.press': "Basın",
    'incrowd.careers': "Kariyerler",
    'incrowd.terms': "Şartlar",
    'incrowd.t_and_c': "Şartlar ve Koşullar",
    'incrowd.faq': "SSS",
    'incrowd.privacy': "Gizlilik",
    'incrowd.copyright': "{{year}} InCrowd Inc, Tüm Hakları Saklıdır",
    'incrowd.blog': "Blog",
    'incrowd.support': "Destek",
    'incrowd.info.ios': "InCrowd ağındaki doktorların doğrudan meslektaşlarına sorular gönderebileceğini biliyor muydunuz? <InCrowd iOS Uygulamasını> kullanarak hemen şimdi deneyin!",
    'incrowd.refer': "Anketlerimize katılmayı seviyor musunuz? Grubumuza katılması için bugün <bir arkadaşınıza önerin> ve her ikiniz de  10 USD (veya kendi para biriminizde değeri) kazanın. Meslektaşınız bir anketi cevaplandırdığında, onlara da bonus gelecektir!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Mikro anketlerin",
    'getstarted.encourage.title.two': "Büyük Etkileri",
    'getstarted.encourage.subtitle': "Basit mikro anketlerle yeni ürün ve hasta tedavi gelişimini etkileyen binlerce nitelikli tıp uzmanlarına katılın ve size de ödeme yapalım!",
    'getstarted.encourage.redirect_to_solutions': "Bir sağlık çalışanı değilsiniz ama InCrowd hakkında daha fazla bilgi mi almak istiyorsunuz?",
    'getstarted.actions.title': "Nitelikli bir tıp uzmanı mısınız?",
    'getstarted.actions.subtitle': "Bugün kaydolun ve sağlık hizmeti odaklı anketler cevaplayarak para kazanmaya başlayın",
    'getstarted.button.continue': "Başla",
    'getstarted.referral': "%{{referrerName}} sayesinde kazandığınız yönlendirme bonuslarına ek olarak anketlerden para kazanmak için kayıt olun",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Hesabınızı oluşturmak için sizden birkaç ayrıntı almamız gerek.",
    'details.profile_details': "Profil Ayrıntıları",
    'details.address_information': "Adres Bilgileri",
    'details.professional_info': "Profesyonel Bilgiler",
    'details.heading.finally': "…ve en sonunda",
    'details.how_receive_surveys': "Anketleri nasıl almak istersiniz?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Temeller",
    'professionchoice.encourage.subtitle': "Mesleğiniz listemizde yok mu? Mesleğinizi eklediğimizde bilgilendirileceğinizden emin olmak için, bize <here> bildirin.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Kimsiniz?",
    'authentication.encourage.subtitle': "InCrowd’un kimliğinizi doğrulaması gerekiyor, ancak şahsi bilgilerinizi hiçbir zaman üçüncü şahıslarla paylaşmayacak veya dağıtmayacağız.",
    'authentication.actions.select_notifications': "Anketleri tarafımızdan nasıl almak istediğinizi seçiniz",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Bilgilerinizi doğruluyoruz. Lütfen biraz bekleyiniz",
    'validation.please_answer': "Kişisel bilgilerinizi doğrulamamıza yardımcı olmak için, lütfen sıradaki soruları cevaplayınız",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Onay",
    'confirmation.validation_success.subtitle': "Kaydınız tamamlandı, InCrowd'a hoşgeldiniz! Kısa süre içinde e-posta ve/veya mesaj olarak doğrulama alacaksınız. Katıldığınız için teşekkürler!",
    'confirmation.validation_error.title': "Problem",
    'confirmation.validation_error.subtitle': "Özür dileriz, %{userFirstName}, kişisel bilgileriniz doğrulanırken bir hata oluştu.",
    'confirmation.actions_title': "Sıradaki ne?",
    'confirmation.go_to_your_profile': "Profilinize gidin",
    'confirmation.validation_success.actions_subtitle': "Birkaç gün içinde e-posta veya mesaj yoluyla 5-10 dakikalık mikro anketlerimizi almaya başlayacaksınız. Henüz mesajla anket almayı tercih etmiyor musunuz? Dilediğiniz zaman InCrowd profilinizden iletişim ayalarınızı değiştirebilirsiniz.",
    'confirmation.validation_error.actions_subtitle': "Bir InCrowd ekip üyesiyle konuşmak ve mevcut sorunları iletmek için lütfen ekranın sağ alt kısmında bulunan açılır pencere sohbeti kullanın.",
    'confirmation.referral.info.1': "2. anket tamamlandıktan sonra %{payoutBusinessDays} iş günü içerisinde siz ve sizi yönlendiren kişi, <%{currency}%{referralBonusAmount} tutarında bonus kazanacaksınız>. %{currency}%{referralBonusAmount} tutarındaki bonus sizin ödül hesabınıza eklenecek. Tercihlerinizi güncellemek, ödüllerinizi incelemek ya da davet edildiğiniz açık anketlerden birisine erişmek için istediğiniz zaman <profil>inizde oturum açabilirsiniz.",
    'confirmation.referral.info.2': "Sorunuz var mı? <Bizimle sohbet edin>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Nitelikli misiniz?",
    'regftr.markets.accepting': "InCrowd cevaplar şuan kabul ediliyor:",
    'regftr.peers.title': "Meslektaşlar",
    'regftr.peers.subtitle': "Yanıtlarınızı meslektaşlarınızın cevapları ile karşılaştırın ve onların yanıtlarından ders çıkarın.",
    'regftr.invites.title': "Davetiyeler",
    'regftr.invites.subtitle': "Kazançlarınızı yükseltmek in e-postanıza veya telefonunuza yeni anket davetiyeleri alın.",
    'regftr.earnings.title': "Kazançlar",
    'regftr.earnings.subtitle': "Kazançlarınızı ve ödeme bilgilerinizi yönetin ve takip edin.",
    'regftr.stats.title': "İstatislikler",
    'regftr.stats.subtitle': "Tüm anket ve kullanıcı bilgilerinizi içeren bir panoya giriş yapın.",

    'contextual_help.sms': "Açık mikro anketlerin SMS bildirimlerini alacaksınız. SMS yoluyla anketlere daha hızlı katılabilir ve daha fazla ödül kazanabilirsiniz. Bilgileriniz gizli tutulur ve sadece anket davetleri için kullanılır.",
    'contextual_help.specialty': "Lütfen sadece NPI ile ilişkili uzmanlık alanlarınızı, tamamladığınız bursları veya ana uzmanlık alanınıza giren diğer tıp alanlarını dahil edin. Gelecekte uzmanlık alanlarınızda değişiklik yapmak isterseniz lütfen support@incrowdnow.com ile iletişime geçin.",
    // USER
    'user(s)': "Kullanıcı |||| Kullanıcılar",
    'user.login': "Giriş",
    'user.logout': "Çıkış",
    'user.register': "Kayıt",
    'user.invitations': "Davetler",
    'user.email': "E-posta",
    'user.pass_word': "Şifre",
    'user.mobile': "Cep Telefonu",
    'user.mobile.hint': "Lütfen %{countryName}) için (+%{phoneCode} ülke kodunu girin",
    'user.title': "Ünvan",
    'user.title_with_example': "Ünvan (mesela Dr., Bayan, Bay)",
    'user.first_name': "İsim",
    'user.last_name': "Soyisim",
    'user.middle_name': "İkinci İsim",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Bir Kullanıcı",
    'user.anonymous_admin': "Admin Kullanıcı",
    'user.dashboard': "Gösterge Tablosu",
    'user.profile': "Profil",
    'user.profile.picture.upload': "Profil resmi yükleyin",
    'user.profile.picture.change': "Değiştir",
    'user.primary_lang': "Ana Dil",
    'user.primary_lang?': "Ana diliniz nedir?",
    'user.survey_langs?': "Hangi dilleri akıcı bir şekilde konuşabilirsiniz?",
    'user.notify_email': "E-posta ile bildir",
    'user.notify_mobile': "Cep telefonuyla bildir",
    'user.contact_support': "Destek Ekibiyle İletişim",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Lütfen <bizimle iletişim kurun>.",
    'user.profession': "Meslek",
    'user.profession?': "Mesleğiniz nedir?",
    'user.join_now': "Şimdi Katıl",
    'user.welcome_back': "Tekrar hoş geldiniz!",
    'user.not_a_member?': "Henüz üye değil misiniz?",
    'user.accept_terms': "Şartları Kabul Et",
    'user.accept_terms.yes': "<Şartlar ve koşulları> kabul ediyorum",
    'user.remember_me': "Bu cihazda hatırla",
    'user.time_zone': "Zaman Dilimi",
    'user.payment.policy': "Ödüllerde her 25%{currency} bakiyeye ulaştığınızda bilgilendirilecek ve InCrowd profiliniz aracılığıyla ödeme seçenekleri arasından seçiminizi yapabileceksiniz. Sorularınız mı var? Aşağıdaki sohbet penceresinden bize ulaşın.",
    'user.country.live_work?': "Hangi ülkede yaşıyor ve çalışıyorsunuz?",
    // FORMS
    'form.button.back': "Geri",
    'form.button.next': "İleri",
    'form.button.cancel': "İptal",
    'form.button.submit': "Gönder",
    'form.button.continue': "Devam Et",
    'form.button.close': "Kapat",
    'form.button.go!': "Git!",
    'form.button.complete!': "Şimdi tamamla!",
    'form.button.update': "Güncelle",
    'form.button.finish': "Bitir",
    'form.button.search': "Ara",
    'form.button.end': "Son",
    'form.search.no_matches': "Eşleşme bulunamadı",
    'form.confirm_email': "E-postayı Onayla",
    'form.confirm_pass_word': "Şifreyi Onayla",
    'form.required_fields': "Gerekli alanlar",
    'form.nothing_selected': "Hiçbir şey seçilmedi",
    'form.confirm_field': "%{formFieldLabel} Onaylayın",
    'form.choice.n/a': "Boş",
    'form.choice.yes': "Evet",
    'form.choice.no': "Hayır",
    'form.choice.blank_for_all': "Hepsini seçmek için boş bırakın",
    'form.choices.select_all': "Hepsini seç",
    'form.choices.deselect_all': "Seçilenlerin hepsini kaldır",
    'form.field.private': "Özel alan",

    // USER ERRORS
    'user.error.dup_email': "Belirtilen e-posta adresiyle zaten başka bir kullanıcı kayıtlı. <Onun yerine oturum aç?>",
    'user.error.dup_sms': "Girilen cep telefonu numarasıyla zaten kayıtlı başka bir kullanıcı var",
  }
})
